import { Normalize } from "@/api/normalize/normalize";
import { djs } from "@/lib/djs";

import type { FichaField } from "./fields";

function isValidDate(raw: string) {
	const date = djs(raw, "DD/MM/YYYY", true);

	if (!date.isValid()) {
		return false;
	}

	const year = date.year();

	return year >= 1900 && year <= djs().year();
}

export function fieldError(field: FichaField, value: string) {
	const filled = value.trim() !== "";

	if (!filled) {
		if (field.optional) {
			return null;
		}

		return "Esse campo é obrigatório";
	}

	if (field.kind === "cpf") {
		const c = Normalize.cpf(value);

		if (!c || !c.valid) {
			return "Confere esse CPF pra mim?";
		}
	}

	if (field.kind === "date" && !isValidDate(value)) {
		return "A data parece incompleta";
	}

	if (field.kind === "email" && !value.includes("@")) {
		return "Falta o @ no e-mail";
	}

	if (field.kind === "tel" && value.replaceAll(/\D/gu, "").length < 11) {
		return "Esse telefone parece incompleto";
	}

	if (field.kind === "cep" && value.replaceAll(/\D/gu, "").length < 8) {
		return "Esse CEP parece incompleto";
	}

	return null;
}
